import { createActions, createReducer } from 'reduxsauce'

import DetalhesMetasEducacaoEmpenhoService from '../../servicos/DetalhesMetasEducacaoEmpenhoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesMetasEducacaoEmpenhoInicio: [],
    buscaDetalhesMetasEducacaoEmpenhoSucesso: ['detalhesMetasEducacaoEmpenho'],
    buscaDetalhesMetasEducacaoEmpenhoErro: ['erro'],
    setDetalhesMetasEducacaoEmpenhoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaDetalhesMetasEducacaoEmpenho = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesMetasEducacaoEmpenhoInicio())
        let serv = new DetalhesMetasEducacaoEmpenhoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaDetalhesMetasEducacaoEmpenhoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesMetasEducacaoEmpenhoErro(error)))
    }
}

const buscaDetalhesMetasEducacaoEmpenhoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesMetasEducacaoEmpenhoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesMetasEducacaoEmpenhoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesMetasEducacaoEmpenho, carregando: false }
}

const setDetalhesMetasEducacaoEmpenhoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_EMPENHO_INICIO]: buscaDetalhesMetasEducacaoEmpenhoInicio,
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_EMPENHO_ERRO]: buscaDetalhesMetasEducacaoEmpenhoErro,
    [Types.BUSCA_DETALHES_METAS_EDUCACAO_EMPENHO_SUCESSO]: buscaDetalhesMetasEducacaoEmpenhoSucesso,
    [Types.SET_DETALHES_METAS_EDUCACAO_EMPENHO_ESTADO_DT]: setDetalhesMetasEducacaoEmpenhoEstadoDT,
})
